import starRatingTemplate from './../templates/starRating';
import fecha from 'fecha';

export default class VerivoxRatings
{
    constructor(producttype = 'power') {
        this.page = 1;
        this.pagesize = 5;
        this.producttype = producttype;
        this.provider = 0;
        this.url = '';
        this.options = {};
        this.totalReviews = 0;
    }

    request($callback, $callbackError) {
        let options = {
            data: {
                type: this.producttype,
                page: this.page,
                pagesize: this.pagesize,
                id: this.provider
            }
        };

        if (this.url === '') {
            return false;
        }

        this.options = options;

        return $.ajax(this.url, options).done($callback).fail($callbackError);
    }

    /**
     * Needed for the ajax request
     * @param url
     * @return {VerivoxRatings}
     */
    setUrl(url) {
        this.url = url;
        return this;
    }

    /**
     * Needed for the ajax request
     * @param provider
     * @return {VerivoxRatings}
     */
    setProvider(provider) {
        this.provider = provider;
        return this;
    }

    /**
     * For config things
     * @param page
     * @return {VerivoxRatings}
     */
    setPagesize(size) {
        this.pagesize = size;
        return this;
    }

    /**
     * Needed for the inifinite scroll
     * @return {VerivoxRatings}
     */
    addPage() {
        this.page++;
        return this;
    }

    /**
     * For config things
     * @param page
     * @return {VerivoxRatings}
     */
    setPage(page) {
        this.page = page;
        return this;
    }

    /**
     * Will create the html content for the modal and inifinite scroll effect
     * @param ratings
     * @return {string}
     */
    prepareModalContent(ratings, provider) {
        let html = `<div class="row">`;
        html += '<div class="column small-12"><span class="modal-headline">Verifizierte Kundenbewertungen</span></div>';
        html += `<div class="column small-12 silent">für ${provider}</div>`;
        html += '<div class="column small-12 silent">In der Darstellung werden Bewertungen der letzten 6 Monate berücksichtigt.</div>';
        html += '</div>';
        html += '<div class="row ratings total-review-result"></div>';
        html += `<div class="review-count text-right"><span class="pagesize">${this.pagesize}</span> von <span class="total-reviews">${this.getTotalReviews()}</span> Bewertungen</div>`;
        html += '<div id="scroll">';
        html += this.getRatingContent(ratings);
        html += '</div></div>';

        return html;
    }

    /**
     * Will return the different columns for the rating
     * @param ratings
     * @return {string}
     */
    getRatingContent(ratings) {
        let html = '';
        let switchAgain = [
            '<span class="wuerdewechseln">Kunde würde wieder zu diesem Anbieter wechseln</span>',
            '<span class="wuerdenichtwechseln">Kunde würde nicht wieder zu diesem Anbieter wechseln</span>'
        ];

        ratings.forEach(rating => {
            html += '<div class="row rating-row">';
            html += `<div class="column small-12 headline">${rating.switchAgain === 'true' ? switchAgain[0] : switchAgain[1]}</div>`;
            html += '<div class="column small-12">';
            html += `<div class="star-ratings" data-rating="${rating.price.percentage}">`;
            html += `<div class="caption">Preis</div>`;
            html += this.getRatingTemplate(rating.price.percentage);
            html += '</div>';
            html += `<div class="star-ratings" data-rating="${rating.service.percentage}">`;
            html += `<div class="caption">Service</div>`;
            html += this.getRatingTemplate(rating.service.percentage);
            html += '</div>';
            html += `<div class="star-ratings" data-rating="${rating.switch.percentage}">`;
            html += `<div class="caption">Anbieterwechsel</div>`;
            html += this.getRatingTemplate(rating.switch.percentage);
            html += '</div>';
            html += '</div>';

            if ('header' in rating) {
                html += `<div class="column small-12 header">${rating.header}</div>`;
            }

            if ('comment' in rating) {
                html += `<div class="column small-12 comment">${rating.comment}</div>`;
            }

            let date = rating.lastModificationDate.split('T');
            date = fecha.parse(`${date[0]} ${date[1]}`, 'YYYY-MM-DD HH:mm');

            html += '<div class="date column small-12">';
            html += `<span class="created">${fecha.format(date, 'DD.MM.YYYY HH:mm')} Uhr</span>`;
            html += `<span class="change-date">${rating.providerSwitchNote}</span>`;
            html += '</div>';
            html += '</div>';
        });

        return html;
    }

    setTotalReviews(reviews) {
        this.totalReviews = reviews;
        return this;
    }

    getTotalReviews() {
        return this.totalReviews;
    }

    /**
     * will return the default html star rating template
     * @return {string}
     */
    getRatingTemplate(percentage) {
        return starRatingTemplate(percentage);
    }

    buildUrl() {
        let url = this.url + '?';

        let options = {
            type: this.producttype,
            page: this.page,
            pagesize: this.pagesize,
            id: this.provider
        };

        $.each(options, (key, value) => {
            url += `${key}=${value}&`;
        });

        return url;
    }
}